export default __webpack_public_path__ + "static/img_process_planning-888f6e713c35ad4061f2eb2deb92e289.jpg";